import React, { memo } from 'react';

const LoadingSpinner = memo(({ size = 'medium', text = 'Loading...' }) => (
    <div className={`loading-spinner loading-spinner--${size}`}>
        <div className="spinner"></div>
        {text && <p>{text}</p>}
    </div>
));

LoadingSpinner.displayName = 'LoadingSpinner';
export default LoadingSpinner;
